import { render, staticRenderFns } from "./GenericTest.vue?vue&type=template&id=33dbf8d8&lang=true"
import script from "./GenericTest.vue?vue&type=script&lang=js"
export * from "./GenericTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports